(function () {
    'use strict';

    angular.module('swif.parcauto')
    .constant('swifParcautoConstant', {
        intervention: {
            content_type: 'intervention',
            routes: {
                dashboard_view: '/parcauto/interventions/dashboard_view'
            }
        },
        automobile: {
            content_type: 'intervention',
            routes: {
                explorer_view: '/parcauto/automobile/explorer_view',
                table_view: '/parcauto/automobile/table_view'
            }
        },
        configuration: {
            routes: {
                configuration_view: '/parcauto/configuration_view',
                brand_view: '/parcauto/configuration_view/brand/table_view',
                model_view: '/parcauto/configuration_view/model/table_view',
                type_view: '/parcauto/configuration_view/type/table_view',
                fuel_view: '/parcauto/configuration_view/fuel/table_view'
            }
        }
    });

})();
